import { FeatureFlagDeclarations } from '../feature-flag-declarations';
import { useFeatureFlag } from './use-feature-flag';

export const useNewTermsAndConditions = () => {
  return useFeatureFlag(FeatureFlagDeclarations.newTermsAndAgreements);
};
